import { render, staticRenderFns } from "./ActivitiesListModal.vue?vue&type=template&id=33088c54&scoped=true&"
import script from "./ActivitiesListModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActivitiesListModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33088c54",
  null
  
)

export default component.exports